import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60svh] items-center justify-center px-6 py-20">
      <div className="mx-auto max-w-xl text-center">
        <p className="font-serif text-7xl font-semibold tracking-tight text-[#00E5A0] sm:text-8xl">
          404
        </p>
        <h1 className="mt-4 font-serif text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
          Page not found
        </h1>
        <p className="mx-auto mt-3 max-w-md text-base leading-relaxed text-muted-foreground">
          The page you're looking for doesn't exist or may have moved. Check the
          address, or head back to the homepage.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild className="bg-[#00E5A0] text-[#0B1120] hover:bg-[#00E5A0]/90">
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild variant="ghost">
            <Link to="/pricing">View pricing</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}